import React, { useCallback } from 'react';
import { shallowEqual, useSelector, connect } from 'react-redux';
import { DeviceContainer } from '@beef/smart-kit';
import classNames from 'classnames/bind';

import { getBasketProductIds, getBasketItems } from 'store/common/basket/selectors';
import {
  getCatalogProductsList,
  selectIsBnplAvailableInProduct,
  selectIsInstallmentAvailableInProduct,
} from 'store/ProductCatalog/products/selectors';
import { isScreenBelow1004, isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { DEVICE_LIST_ROW_PADDING } from 'constants/device';
import commonStyles from 'styles/common.pcss';
import { onDeviceView } from 'store/ProductDetails/common/actions';
import { getBaseUrl } from 'store/ProductDetails/selectors';
import {
  createPushStackedEvent,
  EVENT_CATALOG_PRODUCTS_SEEN_WITH_BNPL,
  EVENT_CATALOG_PRODUCTS_SEEN_WITH_INSTALLMENT,
} from 'pushEvent';

import styles from './styles.pcss';
import { DeviceCard } from './DeviceCard';

const cx = classNames.bind({ ...commonStyles, ...styles });

export const DeviceList_ = ({ onView }) => {
  const {
    productsList,
    basketProductIds,
    isPc,
    isTablet,
    isMobile,
    basketItems,
    hasBnpl,
    baseUrl,
    hasInstallment,
  } = useSelector(
    (state) => ({
      productsList: getCatalogProductsList(state),
      basketProductIds: new Set(getBasketProductIds(state)),
      isPc: !isScreenBelow1004(state),
      isTablet: isScreenBelow1004(state),
      isMobile: isScreenBelow640(state),
      basketItems: getBasketItems(state),
      hasBnpl: selectIsBnplAvailableInProduct(state),
      baseUrl: getBaseUrl(state),
      hasInstallment: selectIsInstallmentAvailableInProduct(state)
    }),
    shallowEqual,
  );

  const notFullRow = productsList.length < 4;
  const isSingle = productsList.length === 1;

  const pushBnplEvent = createPushStackedEvent(EVENT_CATALOG_PRODUCTS_SEEN_WITH_BNPL, baseUrl);
  const pushInstallmentEvent = createPushStackedEvent(
    EVENT_CATALOG_PRODUCTS_SEEN_WITH_INSTALLMENT,
    baseUrl,
  );

  const handleViewed = useCallback((data) => {
    if (hasBnpl[data.id]) {
      pushBnplEvent(data);
    }
    if (hasInstallment[data.id]) {
      pushInstallmentEvent(data);
    }
    onView(data);
  }, []);

  return (
    <DeviceContainer
      previewCardsLength={4}
      rowsSpace={isMobile ? DEVICE_LIST_ROW_PADDING.MOBILE : DEVICE_LIST_ROW_PADDING.DESKTOP}
      contentMaxWidth={167}
      className={cx(
        'container',
        isPc && notFullRow && 'pcDeviceListWrap',
        isTablet && notFullRow && 'tabletDeviceListWrap',
        isMobile && 'mobDeviceListWrapFlex',
        isMobile && isSingle && 'mobDeviceListWrap',
      )}
    >
      {productsList.map((device, index) => (
        <DeviceCard
          key={device.id}
          onViewed={handleViewed}
          device={{
            ...device,
            index,
            isInBasket:
              basketProductIds.has(device.id.toString()) &&
              !(basketItems.filter((item) => item?.id?.toString() === device?.id?.toString()) ||
                [])[0]?.isExcluded,
          }}
        />
      ))}
    </DeviceContainer>
  );
};

const mapDispatchToProps = {
  onView: onDeviceView,
};

export const DeviceList = connect(null, mapDispatchToProps, null, { forwardRef: true })(
  DeviceList_,
);
